export default [
    {
        path: "/parade-state",
        component: () => import("@/App/ParadeState/CreateParade/Components/List.vue"),
        name: "parade-state",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-state/create",
        component: () => import("@/App/ParadeState/CreateParade/Components/Create.vue"),
        name: "parade-state.entry",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-state/:id/show",
        component: () => import("@/App/ParadeState/CreateParade/Components/Show.vue"),
        name: "parade-state.show",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-state/:id/summary",
        component: () => import("@/App/ParadeState/CreateParade/Components/ParadeSummary.vue"),
        name: "parade-state.summary",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-state/:id/details",
        component: () => import("@/App/ParadeState/CreateParade/Components/ParadeDetails.vue"),
        name: "parade-state.details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/parade-state/:id/field-artillery",
        component: () => import("@/App/ParadeState/CreateParade/Components/DetailsFieldArtillery.vue"),
        name: "parade-state-summary-field-artillery",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/parade-state/:id/details-2",
        component: () => import("@/App/ParadeState/CreateParade/Components/ParadeDetails-3.vue"),
        name: "parade-state-summary-details-2",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/company-parade/:id/details/:company_id",
        component: () => import("@/App/ParadeState/CreateParade/Components/CompanyParadeDetails.vue"),
        name: "company-parade-details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/parade-state/:id/edit",
        component: () => import("@/App/ParadeState/CreateParade/Components/Edit.vue"),
        name: "parade-state.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
